import { render } from "./LegalDisclaimer.vue?vue&type=template&id=94294d94&scoped=true"
import script from "./LegalDisclaimer.vue?vue&type=script&lang=js"
export * from "./LegalDisclaimer.vue?vue&type=script&lang=js"

import "./LegalDisclaimer.vue?vue&type=style&index=0&id=94294d94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94294d94"]])

export default __exports__